module.exports = __webpack_public_path__ + "static/images/cash-v2.bV6B1az.svg";